package com.havn.app.features.auth.data

internal actual fun havnScreenshotSessionJson(): String? = null
